import { Link } from 'react-router-dom';

import { ROUTES, SITE } from '@/constants';
import { cn } from '@/utils';

import { LogoMark } from '../LogoMark';

import styles from './Logo.module.css';

export interface LogoProps {
  /** White wordmark, for use on the dark footer. */
  inverted?: boolean;
  className?: string;
}

export function Logo({ inverted = false, className }: LogoProps) {
  return (
    <Link
      to={ROUTES.home}
      className={cn(styles.logo, className)}
      aria-label={`${SITE.name} — home`}
    >
      <LogoMark inverted={inverted} title={SITE.name} />
    </Link>
  );
}
